import { useEffect } from "react";
import { AttributionService } from "../services/attribution.service";
import { devLog, devWarn } from "../services/util";

const AttributionCapture: React.FC = () => {
  useEffect(() => {
    try {
      const existing = AttributionService.retrieve();
      const searchParams = new URLSearchParams(window.location.search);
      const newAttribution = AttributionService.extractFromUrl(searchParams);

      // First touch wins. This used to spread the new values over the stored ones, which made it
      // last-touch here while AttributionService.storeFromCurrentUrl was first-touch - the same
      // field meant different things depending on which path ran. Original source is what the
      // attribution is for, so both are first-touch now, within the 24h TTL.
      const mergedAttribution = {
        ...newAttribution,
        ...existing,
        urlReferrer:
          existing?.urlReferrer || newAttribution.urlReferrer || null,
        signUpSource: existing?.signUpSource || newAttribution.signUpSource,
        abTestSource: existing?.abTestSource || newAttribution.abTestSource,
      };

      // Store if we have any new attribution data or improvements
      if (
        newAttribution.urlReferrer ||
        newAttribution.signUpSource ||
        !existing
      ) {
        AttributionService.store(mergedAttribution);
        devLog("Attribution captured/updated on app load:", {
          existing,
          new: newAttribution,
          merged: mergedAttribution,
        });
      } else {
        devLog("Attribution already complete, no updates needed:", existing);
      }
    } catch (error) {
      devWarn("Attribution capture failed:", error);
    }
  }, []);

  return null;
};

export default AttributionCapture;
